import styles from '../Interview.module.scss'

type Props = {
  text: string
}

const SubTitle: React.FC<Props> = ({ text }) => {
  return <h4 className={styles.subTitle}>{text}</h4>
}
export default SubTitle
